<template>
  <div class="page w">
    <div class="main">
      <div class="cy-content">
        <div class="cy-tabs">
          <div style="height: 100%;">
            <div class="cy-tab"  @click="search(1,1)">
              <div class="icon">
                <img data-v-9b182bc0=""
                     src="data:image/png;base64,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">
              </div>
              <div class="info">
                <div class="title">软件服务专题库</div>
                <!--                <div class="eng"> Technological</div>-->
                <!--                <div class="eng"> Innovation</div>-->
              </div>
            </div>
          </div>
          <div style="height: 100%;">
            <div class="cy-tab"  @click="search(1,2)">
              <div class="icon"><img data-v-9b182bc0=""
                                     src="data:image/png;base64,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">
              </div>
              <div class="info">
                <div class="title">装备制造专题库</div>

              </div>
            </div>
          </div>
          <div style="height: 100%;">
            <div class="cy-tab"  @click="search(1,3)">
              <div class="icon"><img data-v-9b182bc0=""
                                     src="data:image/png;base64,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">
              </div>
              <div class="info">
                <div class="title">建筑及新材料专题库</div>

              </div>
            </div>
          </div>
          <div style="height: 100%;">
            <div class="cy-tab"  @click="search(1,4)">
              <div class="icon"><img data-v-9b182bc0=""
                                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA8CAMAAAAJ1/l9AAAAAXNSR0IArs4c6QAAAapQTFRFAAAAAAD/AID/AFX/Var/AIC/AID/M2b/K4D/JG3bIGDfIID/HHH/LnToJ3brJG3tN3//MHDvLXjwK3HxK4DxKHnkKHnyM4DyLnToLnTzK3XqK3X0KXrrKXr1J3brMXb1L3vsKnfuKXPvMHjvLXjwLHXpLHXwK3jxMHXxL3LrLnbyLXPsLHbsLHbzK3PtL3fzLnTuLnrzLXfuLHTuK3fvL3jvLnXrLXjwLHbwK3PsK3jxLnbtLXTtLHLtLHftK3XuL3fuLnXuLnXyLXfvLXXvMHjvL3bvLnTwLnjwLnbwLXjwLHbwL3fxLXfuLXXuLHfuLHXuL3XuLnfuLnfyLnbvLXfvLXbvLHjvL3jvL3bsL3bvLnbwLXXtLHftLHfwLnfuLnXxLXfuLXfxLXbuL3fxLXXvLXbvLHXvLnXtLnXwLnjwLXftLXfwLXfuLnbuLXfxLXbuLHXvLnbvLnbvLXXvLXjvLXftLXfvL3btL3bvLnfwLnbuLXfuLXbuLXbwLXfuLXfwLHbuLHbwLnbuLnbwLnXuLnbuLXXvLXfvLXbvLXXvL3fvLHbvLnbvmtmifwAAAI50Uk5TAAECAwMEBAUGBwgICQsNDg4QERISExMUFhYYGBkZGhobHh8gIiMjJCUmJygpKSorLCwtLi8xMjM0NTU4OTo6Ozw9PT4/QEFCQkNERUdJSktMTE1NTk9QUVFSUlRVVlZYWVpaW1xgYWJkZGRlZWdqa2xtbnBxcXJyc3N0dXZ3d3h4eXl5eXp7fHx9fn5/fwOuIEEAAAKQSURBVEjH7Zb7X0txGMefHTRCc4qhUDG5hFw2i9hKJ5d0MXKpDDkiViOXoqKi0uT9P/thnbPv6mxns9/k89PzfM95v87rPN/nJvJPyXflZMbZdjmoWfamULPXHX8PZ23nKVy37C4YcKXLgU7b+wimZQ/DW1d8O3Db9j4p+Et49x/PqerwDeCVYWkWxi37A0yHq/PAJ5K4Knk8F91OIVppd6bPAzD/LY/mATjnRGuTwL2K/LGp6AMmNYcnAeCRe0n0AwGH8xagVkQ8gajhqGjAIyK1QEuG8kQfx+PxeDyeBHQRfSx31MZ0ER1IponBqEeC6nNdtLx3l9REV/2ghLLxRiD11VEpoDEbD4nWMWSapmma44AubUCdePdqIuIvF5GqHdZv1gFtogPjaWKoQ7kCA9DFAHy7vvBGkyf8OCS9LB21uhhgiA4YDpFX8IvAPi9wUxbgbrH4JeBAuvSW4cGGwi/A78rNKbgmM9BdLO41p2+JRKaGd0ro82s9H74mbQzAl2N62biSNmuStiBcSdpgKXhQPNFBtWCz8C2tz16s6nnH1gyuFKxT6Kyj++qXhgqOvHU0y0Drqu7wa3ex+DKnLbMe9hePD1qNru+vcFVF45MqvaQXi3epeKdz5EO9sVgsFouNrscPK13+jJI2o2miNyTSlJ116VbpqEyrtNUkzaU06mYp6xlJJBKJRGKi8DExkSZGesrWzTi3IbVmxmVN2H73EZlrwpY4363tYjE1l1knFlLfbXsutZhnuxBpXylltyl1sxKRmrAJdFvRegh20XUDZrjGZXeJAH7LOQZ2yfuBiOvqs9HxPSp+SsGvuuINMGUXkv6TpcpV2zvDSr371tkQqco4ByOZi/ZHjqx7+Q8+1uzfIj1SjAAAAABJRU5ErkJggg==">
              </div>
              <div class="info">
                <div class="title">生物农业专题库</div>

              </div>
            </div>
          </div>

        </div>
        <div class="left-arrow">
          <div class="l-san"></div>
        </div>
        <div class="right-arrow">
          <div class="r-san"></div>
        </div>
      </div>

    </div>


    <!-- 知识产权的列表信息 -->
    <div class="patent-card">
      <el-row style="margin-left: -10px;margin-right: -10px;" >
        <div class="item-card" v-for="patent in patentList">
          <el-col :span="6"  >

            <router-link :to="'/patentDetail/'+patent.id" target="_blank">
              <el-card :body-style="{ padding: '0px' }">


                <block v-if="patent.yyptPicUrl!=undefined  && patent.yyptPicUrl!='' ">
                  <!--                  <img :src='`${patent.yyptPicUrl}`' alt="">-->
                  <img :src='`${domain}${patent.yyptPicUrl}`' alt="" class="image">
                </block>
                <block v-else>
                  <img v-if="patent.patentType=='软件著作权'"
                       src="../../assets/images/ruanzhu.jpg"
                       class="image"/>
                  <img v-else
                       src="../../assets/images/zhuanli.png"
                       class="image"/>
                </block>


                <div class="remarks ellipsis" style="padding: 14px">
                  <el-tooltip
                      class="box-item"
                      effect="dark"
                      :content="patent.name"
                      placement="top-start">
                    <span class="name">{{ patent.name }}</span>
                  </el-tooltip>
                  <div class="bottom">
                    <span>授权号:{{ patent.grantNo }}</span>
                    <span>{{ patent.userFirst }}</span>
                  </div>
                </div>
              </el-card>
            </router-link>



          </el-col>
        </div>
      </el-row>
    </div>

    <!--分页-->
    <div class="pagination">
      <el-pagination
          :page-size="pageSize"
          :pager-count="10"
          background
          layout="prev, pager, next"
          :total="totalNum"
          :hide-on-single-page="totalNum<=0"
          v-model:current-page="currentPage"
          @current-change="handelCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import {reactive, ref} from 'vue'
import {getLibraryList} from '@/api/Patent.js'
import {toRaw} from '@vue/reactivity'
import { useRoute } from 'vue-router';


export default {
  setup(props) {
    const domain = ref(process.env.VUE_APP_DOMAIN)
    return {domain};
  },
  data() {
    return {
      patentList: [],  // 当前显示的知识产权内容
      pageNo: 1,  // 当前页面
      pageSize: 8,  // 每页显示8个
      totalNum: 1000,  // 一共多少条记录
      currentPage: 1, // 当前页
      ztId:1
    }
  },
  mounted() {
    this.search(0,1);
  },

  methods: {
    // 获取专题库的内容
    async search(pageNo,ztId) {

      let params = {};
      params.pageSize = 4;
      params.pageNo = pageNo;
      params.orderBy = "grant_no desc";
      params.ztid = ztId;
      let result = await getLibraryList(params);
      console.log("查询结果：", result)
      this.patentList = result.rows
      this.totalNum = result.total
      this.ztId = ztId
    },

    handelCurrentChange(value) {
      console.log("选中的页码：",value)
      this.search(value,this.ztId)
    },

    imgOnError(e){
      //  onerror="this.src='http://localhost:8081/patent/userfiles/1/%E7%A8%8B%E5%BA%8F%E9%99%84%E4%BB%B6//cms/display/carousel/2022/11/defaultImg.jpg'"
      let img = e.srcElement;
      img.src = this.domain+'/patent/userfiles/1/%E7%A8%8B%E5%BA%8F%E9%99%84%E4%BB%B6//cms/display/carousel/2022/11/defaultImg.jpg';
      img.onerror = null; //防止闪图
    },
  }
};
</script>


<style lang="less" scoped>
div {
  box-sizing: border-box;
}
.image {
  border: 0;
  vertical-align: middle;
  width: 223px;
  height: 270px;
  padding: 30px;
}
.page {
  min-height: 600px;

  .main {
    background: #fff;
    padding: 30px 0;
    border-radius: 6px;

    .cy-content {
      position: relative;

      .cy-tabs {
        margin: 0 30px;
        display: flex;

        justify-content: space-around;
        .cy-tab{
          padding-top: 10px;
          width: 162px;
          height: 130px;
          text-align: center;
          color: #666;

          &:hover{
            cursor: pointer;
            background: #ecf5ff;
          }
          .icon{
            line-height: 50px;
          }
          .info{
            margin-top: 8px;
            .title{
              font-weight: 700;
              margin-bottom: 10px;
            }
            .eng{
              font-size: 12px;
              line-height: 20px;
              text-transform: uppercase;
              transform: scale(.85);
            }
          }
        }
      }

      .left-arrow {
        width: 20px;
        height: 130px;
        background: rgba(0,0,0,.2);
        color: #fff;
        position: absolute;
        left: 5px;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px 0 0 10px;
      }

      .right-arrow {
        width: 20px;
        height: 130px;
        background: rgba(0,0,0,.2);
        color: #fff;
        position: absolute;
        right: 5px;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0 10px 10px 0;
      }
    }
  }


  .patent-card {
    //display: flex;
    //flex-wrap: wrap;
    //justify-content: space-around;
    margin-top: 20px;
    .item-card{
      width: 305px;
      padding: 0 10px;
      box-sizing: border-box;
    }
    //.image{
    //  width: 283px;
    //  height: 330px;
    //}
    .remarks {
      box-sizing: border-box;
      width: 283px;
      overflow: hidden;
      .name {
        font-size: 16px;
        font-weight: 600;
      }
      .bottom {
        margin-top: 5px;
        display: flex;
        flex-direction: column;
        span {
          display: inline-block;
          margin: 5px 0 5px 0;
        }
      }
    }
  }



  .el-card {
    margin: 15px 0;
    width: 283px;
  }

  .el-pagination {
    margin-top: 10px;
    justify-content: center; //居中
  }
}
</style>